var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1264,
    height: 402,
    viewBox: "0 0 1264 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_f_13_533)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 631.64,
    cy: 348.861,
    rx: 379.069,
    ry: 95.8576,
    fill: "#003A9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13_533",
    x: 0.0947113,
    y: 0.52684,
    width: 1263.09,
    height: 696.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 126.238,
    result: "effect1_foregroundBlur_13_533"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterShape);
export default __webpack_public_path__ + "static/media/footer-shape.777a35a1f5f0f1a20ce2d7f7e573be40.svg";
export { ForwardRef as ReactComponent };